import React, { Fragment, useRef } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Input, FormGroup } from "reactstrap"
import { DefaultColumnFilter } from "components/Common/filters"
import { useEffect } from "react"
import { useState } from "react"
import JobListGlobalFilter from "components/Common/GlobalSearchFilter"
import Flatpickr from "react-flatpickr";

// Define a default UI for filtering
function GlobalFilter({
  setGlobalFilter,
  isJobListGlobalFilter,
  filterData,
  value,
  setValue,
}) {
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
    filterData(value)
  }, 200)

  return (
    <React.Fragment>
      <div className="search-box  d-inline-block">
        <div className="position-relative">
          <label htmlFor="search-bar-0" className="search-label">
            <span id="search-bar-0-label" className="sr-only">
              Search this table
            </span>
            <input
              onChange={e => {
                setValue(e.target.value)
                onChange(e.target.value)
              }}
              id="search-bar-0"
              type="text"
              className="form-control"
              placeholder={"Search…"}
              value={value || ""}
            />
          </label>
          <i className="bx bx-search-alt search-icon"></i>
        </div>
      </div>
      {isJobListGlobalFilter && <JobListGlobalFilter />}
    </React.Fragment>
  )
}

const DCTaskTable = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddTaskTitleList,
  handleTaskClick,
  className,
  filterData,
  pagePerSize,
  isLoading,
  TotalRecords,
  statusFilter, setStatusFilter,
  setDateFilter, dateFilter, users,
  userFilter, setUserFilter,
  setdateDisble, dateDisble,
  writeDataToExcel, totalDCFigure
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageSize: 20,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useExpanded,
    usePagination
  )
  const handlesort = column => { }
  const [pageIndex, setpageIndex] = useState(1)
  const [prevValue, setPrevValue] = useState();


  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? "🔽" : "🔼") : ""
  }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
  }

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0
    gotoPage(page)
  }

  const [isMobile, setisMobile] = useState(window.innerWidth < 924)
  const [value, setValue] = React.useState()
  const [displaySubAdmin, setDisplaySubAdmin] = useState(false)
  const [isIpad, setIsIpad] = useState(window.innerWidth < 924)

  useEffect(() => {
    pagePerSize(pageSize, pageIndex, value)
    setPrevValue(value);
  }, [pageSize, value, pageIndex])

  useEffect(() => {
    if (value !== prevValue) {
      setpageIndex(1);
    }
  }, [value]);

  useEffect(() => {
    setpageIndex(1);
  }, [pageSize]);

  const margin = {
    marginTop: isMobile ? "" : "",
  }

  const handleClick = () => {
    setdateDisble(!dateDisble);
  }
  const checkbox = useRef();
  const flatpickrRef = useRef(null);


  return (
    <Fragment>
      <Row className="">
        <Col md={9} style={{ marginTop: "10px" }}>
          <Row>
            <Col md="2" className="table-header" >
              <select
                className="form-select"
                value={pageSize}
                onChange={onChangeInSelect}
              >
                {[10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </Col>
            <Col md="2" className="table-header " style={{ marginTop: isMobile ? "5px" : "0px " }}>
              {isGlobalFilter && (
                <GlobalFilter
                  preGlobalFilteredRows={preGlobalFilteredRows}
                  globalFilter={state.globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  isJobListGlobalFilter={isJobListGlobalFilter}
                  filterData={filterData}
                  value={value}
                  setValue={setValue}
                />
              )}
            </Col>
            <Col md="2" className="table-header" style={{ paddingLeft: isMobile ? "" : "0px", padding: isMobile ? "" : "0px", marginBottom: isMobile ? "10px" : '' }} >
              <select
                className="form-select"
                value={statusFilter}
                onChange={e => setStatusFilter(e.target.value)}
              >
                <option value={0}>Select Status</option>
                <option value={1}>Assigned</option>
                <option value={2}>In-Progress</option>
                <option value={3}>Done</option>
                <option value={4}>Discard</option>
              </select>
            </Col>
            <Col md="2" className="table-header" style={{ marginBottom: isMobile ? "10px" : '' }} >
              <Input
                type="select"
                id="validationCustom01"
                className="form-control"
                name="taskType"
                // onChange={validation.handleChange}
                onChange={e => {
                  setUserFilter(e.target.value)
                }}
                value={userFilter}
              >
                <option value={0}>Select User</option>
                {users.map((item, index) => {
                  return (
                    <option key={index} value={item.Key}>
                      {item.Value}
                    </option>
                  )
                })}
              </Input>
            </Col>
            <Col md={4} className="" style={{ padding: isIpad ? "" : "0px" }}>
              <FormGroup className="mb-2">
                <div className="d-flex" >
                  <div className="form-control " onClick={() => handleClick()} style={{ width: "40px", borderRight: "none", backgroundColor: "#EFF2F7", display: "flex", alignItems: "center", cursor: "pointer" }}>
                    <input
                      id="checkbox"
                      type="checkbox"
                      style={{ width: "15px", height: "15px", cursor: "pointer" }}
                      checked={dateDisble}
                      onChange={e => setdateDisble(e.target.checked)}
                      ref={checkbox}
                    />
                  </div>
                  <Flatpickr
                    ref={flatpickrRef}
                    disabled={!dateDisble}
                    className="form-control d-block"
                    placeholder="dd M,yyyy"
                    options={{
                      mode: "range",
                      dateFormat: "d-m-Y"
                    }}
                    value={dateFilter}
                    onChange={(e) => { setDateFilter(e) }}

                  />
                  <i
                    className="fas fa-calendar-alt calander-icon"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      flatpickrRef.current.flatpickr.open();
                    }}
                  ></i>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </Col>
        <Col md={isIpad ? 12 : 3} style={{ display: "flex", justifyContent: "end" }}>
          <Row>
            <Col md={(isIpad || isMobile) ? 12 : 5}>
              <div style={{ marginTop: "10px", textAlign: isIpad ? "end" : "end", padding: isMobile ? '' : "0px" }}>
                {data.length > 0 ? (<button
                  type="button"
                  className="btn btn-excel  btn-label"
                  onClick={writeDataToExcel}
                >
                  Excel <i className="far fa-file-excel label-icon"></i>
                </button>) : (<button
                  type="button"
                  className="btn  btn-excel  btn-label"
                  style={{ cursor: "not-allowed" }}
                >
                  Excel <i className="far fa-file-excel label-icon"></i>
                </button>)}
              </div>
            </Col>
            <Col md={7} style={{ marginTop: "22px" }}>
              <div style={{ color: "#0F6E25", fontSize: "16px" }}>Total Figure: {totalDCFigure || 0}</div>
            </Col>
          </Row>
        </Col>

      </Row>


      <div className="table-responsive react-table">
        <Table bordered  {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    onClick={() => {
                      handlesort(column)
                    }}
                    {...column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                        width: column.width,
                      },
                    })}
                  >
                    <div className={`mb-0`}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {page.length ? (
            <tbody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr>
                      {row.cells.map(cell => {
                        const { Status } = cell.row.original;
                        return (
                          <td
                            key={cell.id}
                            className={`${Status == 3 ? "status-done" : Status == 4 ? "status-discard" : ""} text-nowrap`}
                            {...cell.getCellProps({
                              style: {
                                minWidth: cell.minWidth,
                                maxWidth: cell.maxWidth,
                                width: cell.width,
                                padding: '10px',
                              },
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })}
            </tbody>
          ) : (
            <tbody
              style={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                height: "40px",
              }}
            >
              <tr>
                <td colSpan={headerGroups[0].headers.length}>
                  {isLoading ? "Loading..." : "No Record Found"}
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex - 1)}
              disabled={pageIndex == 1}
            >
              {"<<"}
            </Button>
            {/* <Button
              color="primary"
              onClick={previousPage}
              // disabled={!canPreviousPage}
            >
              {"<"}
            </Button> */}
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page
          <strong style={{ marginLeft: "5px" }}>
            {TotalRecords == 0 ? 1 : pageIndex} of {TotalRecords == 0 ? 0 : Math.ceil(TotalRecords / pageSize)}
          </strong> | Total <strong>{TotalRecords}</strong>
        </Col>
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            {/* <Button color="primary" onClick={nextPage} disabled={!canNextPage}> */}
            {/* <Button color="primary" onClick={pageIndex}>
              {">"}
            </Button> */}
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex + 1)}
              disabled={pageIndex == (pageIndex == 1 && TotalRecords == 0 ? Math.ceil(TotalRecords / pageSize) + 1 : Math.ceil(TotalRecords / pageSize))}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  )
}

DCTaskTable.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DCTaskTable
